import * as tslib_1 from "tslib";
import { ChangeDetectorRef, DoCheck, OnInit } from '@angular/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { forceApplyUnmatchedTruthyTogglesToDom, mergeNgxPdfFormDataFromDomAnnotationLayer, mergeNgxPdfFormDataIntoStored, pdfCheckboxRawToChecked, pdfRadioRawToChecked, resolveAcroFormDataValue, } from 'src/app/core/utils/pdf-acroform-data-resolve';
export class DocumentViewerComponent extends BaseManagement {
    constructor(mainService, translate, ngxService, transactionService, cdr) {
        super();
        this.mainService = mainService;
        this.translate = translate;
        this.ngxService = ngxService;
        this.transactionService = transactionService;
        this.cdr = cdr;
        this.validateForm = false;
        this.isPDF = false;
        this.isPdfForm = false;
        this.serverError = '';
        this.isFormValid = false;
        /** Solo mostrar el PDF cuando formData ya esté preparado, para evitar campos en blanco por race condition */
        this.formDataReady = false;
        /** ngx-extended-pdf-viewer 9: montar tras un tick para que [formData] esté estable (README v7.1: evitar destroy+recreate inmediato). */
        this.ngxMountReady = false;
        /** El visor vive en app.component (singleton); ngOnInit no se repite al abrir otro PDF. */
        this.lastViewerSnapshot = '';
        this.validationTimer = null;
        /** Copia tomada al preparar el visor; evita que pagesLoaded aplique antes/después con formData distinto. */
        this.acroFormHydrateSnapshot = null;
        this.acroHydrationTimers = [];
    }
    checkIfPDF() {
        if (typeof this.mainService.fileToLoad === 'string') {
            let extension = this.getFileExtension(this.mainService.fileToLoad);
            this.isPDF = extension.toLowerCase() === 'pdf';
        }
    }
    getFileExtension(fileName) {
        const parts = fileName.split('.');
        return parts[parts.length - 1];
    }
    ngOnInit() {
        this.lastViewerSnapshot = '';
    }
    ngDoCheck() {
        const snap = this.computeViewerSnapshot();
        if (!this.mainService.fileToLoad) {
            if (this.lastViewerSnapshot !== '') {
                this.lastViewerSnapshot = '';
                this.formDataReady = false;
                this.ngxMountReady = false;
            }
            return;
        }
        if (snap !== this.lastViewerSnapshot) {
            this.lastViewerSnapshot = snap;
            this.prepareViewerForCurrentPdf();
        }
    }
    computeViewerSnapshot() {
        if (!this.mainService.fileToLoad) {
            return '';
        }
        const cr = this.mainService.currentRequirement;
        const json = cr && cr.PdfFormJson != null ? String(cr.PdfFormJson) : '';
        return `${this.mainService.pdfViewSessionId}|${this.mainService.fileToLoad}|${json}`;
    }
    prepareViewerForCurrentPdf() {
        if (this.validationTimer) {
            clearTimeout(this.validationTimer);
            this.validationTimer = null;
        }
        this.clearAcroHydrationTimers();
        this.acroFormHydrateSnapshot = null;
        this.formDataReady = false;
        this.ngxMountReady = false;
        this.checkIfPDF();
        const cr = this.mainService.currentRequirement;
        this.isPdfForm =
            !!cr &&
                (cr.RequirementTypeId === 10 || cr.RequirementTypeName === 'PdfForm');
        this.patchPdfFormData();
        this.acroFormHydrateSnapshot = this.mainService.formData
            ? Object.assign({}, this.mainService.formData) : {};
        this.formDataReady = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.ngxMountReady = true;
            this.cdr.detectChanges();
        }, 0);
        this.validationTimer = setTimeout(() => {
            this.validationTimer = null;
            this.validateFormManually();
        }, 1200);
    }
    clearAcroHydrationTimers() {
        this.acroHydrationTimers.forEach((t) => clearTimeout(t));
        this.acroHydrationTimers = [];
    }
    /**
     * Si hay PdfFormJson, siempre es la fuente de verdad (evita datos del PDF anterior
     * cuando el antiguo patch hacía early-return si formData ya tenía claves).
     */
    patchPdfFormData() {
        const cr = this.mainService.currentRequirement;
        this.mainService.formData = this.mainService.parsePdfFormJsonToFilteredFormData(cr && cr.PdfFormJson != null ? String(cr.PdfFormJson) : null);
    }
    // Manual validation method
    validateFormManually() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('validateFormManually called, validateForm:', this.validateForm);
            if (!this.validateForm) {
                this.isFormValid = true;
                console.log('Validation disabled, setting isFormValid to true');
                return;
            }
            try {
                const formData = yield this.ngxService.getFormData();
                console.log('Form data retrieved:', formData);
                const missingFields = [];
                for (const field of formData) {
                    const a = field.fieldAnnotation;
                    const isCheckbox = a &&
                        (typeof a.isChecked === 'boolean' ||
                            (a.checkBox && typeof a.checkBox.isChecked === 'boolean'));
                    let fieldValue = '';
                    if (isCheckbox) {
                        fieldValue =
                            typeof a.isChecked === 'boolean'
                                ? a.isChecked
                                    ? '1'
                                    : ''
                                : a.checkBox && a.checkBox.isChecked
                                    ? '1'
                                    : '';
                    }
                    else {
                        fieldValue = a && a.value ? a.value : '';
                    }
                    console.log('Checking field:', field.name, 'value:', fieldValue);
                    if (field.name && field.name.toLowerCase().includes('required')) {
                        let checked = false;
                        if (isCheckbox && a) {
                            if (typeof a.isChecked === 'boolean') {
                                checked = a.isChecked;
                            }
                            else if (a.checkBox && typeof a.checkBox.isChecked === 'boolean') {
                                checked = a.checkBox.isChecked;
                            }
                        }
                        const isEmpty = isCheckbox
                            ? !checked
                            : !fieldValue || String(fieldValue).trim() === '';
                        console.log('Required field:', field.name, 'isEmpty:', isEmpty);
                        if (isEmpty) {
                            missingFields.push(field.name);
                        }
                    }
                }
                this.isFormValid = missingFields.length === 0;
                console.log('Missing fields:', missingFields);
                console.log('isFormValid:', this.isFormValid);
            }
            catch (error) {
                console.error('Error during form validation:', error);
                this.isFormValid = false;
            }
        });
    }
    close() {
        this.clearAcroHydrationTimers();
        this.acroFormHydrateSnapshot = null;
        this.ngxMountReady = false;
        this.mainService.closePdfView();
    }
    /**
     * PdfForm (técnico): sin [formData] en ngx 9 para que pdf.js dibuje todos los widgets (checkboxes).
     * Hidratamos desde PdfFormJson en la capa de anotación; `fd` capturado aquí evita pisar valores con formDataChange.
     */
    onAcroFormPagesLoaded() {
        this.clearAcroHydrationTimers();
        const fd = this.acroFormHydrateSnapshot != null
            ? Object.assign({}, this.acroFormHydrateSnapshot) : this.mainService.formData
            ? Object.assign({}, this.mainService.formData) : null;
        if (!fd || typeof fd !== 'object') {
            return;
        }
        const apply = () => this.applyFormDataToAnnotationLayer(Object.assign({}, fd));
        const delays = [0, 80, 200, 400, 600, 1000, 1500, 2200, 3000, 4000];
        delays.forEach((ms) => {
            const id = setTimeout(apply, ms);
            this.acroHydrationTimers.push(id);
        });
    }
    applyFormDataToAnnotationLayer(formData) {
        const nodes = document.querySelectorAll('.annotationLayer input, .annotationLayer textarea, .annotationLayer select');
        nodes.forEach((node) => {
            const element = node;
            const fieldName = (element.name || '').trim() || element.id;
            if (!fieldName) {
                return;
            }
            const { value: raw, found } = resolveAcroFormDataValue(formData, fieldName);
            const type = (element.type || '').toLowerCase();
            if (type === 'checkbox') {
                if (!found) {
                    element.checked = false;
                }
                else {
                    element.checked = pdfCheckboxRawToChecked(raw, element);
                }
            }
            else if (!found) {
                return;
            }
            else if (type === 'radio') {
                element.checked = pdfRadioRawToChecked(raw, element);
            }
            else {
                element.value = raw != null ? String(raw) : '';
            }
            element.dispatchEvent(new Event('input', { bubbles: true }));
            element.dispatchEvent(new Event('change', { bubbles: true }));
        });
        forceApplyUnmatchedTruthyTogglesToDom(formData);
        this.cdr.detectChanges();
    }
    tryUpdateFormData(action) {
        console.log('tryUpdateFormData called, isFormValid:', this.isFormValid);
        if (!this.isFormValid) {
            this.alertCompleteForm();
            return;
        }
        if (this.isSaving())
            return;
        this.translate
            .get([
            'message.deleteConfirmText',
            'message.yes',
            'message.no',
            'message.requirement',
            'message.deleted',
            'message.unableRequirement',
            'message.done',
            'pdfform.saveWarn',
        ])
            .subscribe((translations) => {
            const dialogRef = this.dialog.open(DialogYesNoComponent, {
                width: '250px',
                data: {
                    msg: translations['pdfform.saveWarn'],
                    yesText: translations['message.yes'],
                    noText: translations['message.no'],
                },
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 1) {
                    this.startSaving(action);
                    this.updateFormData(action);
                }
            });
        });
    }
    updateFormData(action) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.mainService.formData = mergeNgxPdfFormDataFromDomAnnotationLayer(this.mainService.formData);
            var formData = new FormData();
            var files = [];
            Array.from(files).forEach((f) => formData.append('file', f));
            let params = [];
            params.userProcessId = this.mainService.currentRequirement.ProcessId;
            params.userProcessRequirementId = this.mainService.currentRequirement.UserProcessRequirementId;
            // Convertir saltos de línea a etiquetas HTML <br>
            console.log('📋 Datos originales:', this.mainService.formData);
            const sanitizedFormData = this.convertNewLinesToHtml(this.mainService.formData);
            console.log('✅ Datos con <br>:', sanitizedFormData);
            formData.append('pdfFormJson', JSON.stringify(sanitizedFormData));
            this.mainService.updatePdfFormInternal(params, formData)
                .then((updatedRequirement) => {
                // this.mainService.pdfCommunicator.next("stop-saving");
                this.stopSaving();
                this.mainService.currentRequirement = updatedRequirement.Data;
                this.mainService.updateItemByField(this.mainService.currentRequirement.UserProcessRequirementId, 'UserProcessRequirementId', this.mainService.currentRequirement);
                this.close();
            })
                .catch((err) => {
                console.log('error', err);
                this.translate
                    .get(['error.documentUplaod'])
                    .subscribe((translations) => {
                    this.stopSaving();
                    this.serverError = "Hubo un problema al intentar enviar el documento";
                });
            });
        });
    }
    downloadPdfWithFormData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isPdfForm) {
                var requirementId = this.mainService.currentRequirement
                    && this.mainService.currentRequirement.UserProcessRequirementId;
                if (!requirementId)
                    return;
                try {
                    var data = yield this.mainService.getFilledPdf(requirementId);
                    var blob = new Blob([data], { type: 'application/pdf' });
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'documento.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                catch (err) {
                    console.error('Error downloading filled PDF:', err);
                    this.serverError = 'Error al descargar el documento.';
                }
            }
            else {
                var a = document.createElement('a');
                a.href = this.mainService.fileToLoad;
                a.download = '';
                a.target = '_blank';
                a.click();
            }
        });
    }
    onFormChange(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (event && typeof event === 'object') {
                this.mainService.formData = mergeNgxPdfFormDataIntoStored(this.mainService.formData, event);
            }
            yield this.validateFormManually();
        });
    }
    alertCompleteForm() {
        const dialogRef = this.dialog.open(DialogOkComponent, {
            data: {
                msg: 'Rellene todos los campos obligatorios.',
            }
        });
        dialogRef.afterClosed().subscribe((res) => { });
    }
    /**
     * Convierte los saltos de línea (\n) a etiquetas HTML <br> para que se
     * muestren correctamente en el PDF generado
     * @param data Objeto con los datos del formulario
     * @returns Objeto con los datos convertidos
     */
    convertNewLinesToHtml(data) {
        const converted = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                let value = data[key];
                // Si es un string, convertir saltos de línea a <br>
                if (typeof value === 'string') {
                    // Normalizar diferentes tipos de saltos de línea
                    value = value.replace(/\r\n/g, '\n'); // Windows
                    value = value.replace(/\r/g, '\n'); // Mac antiguo
                    // Convertir \n a <br>
                    value = value.replace(/\n/g, '<br>');
                }
                converted[key] = value;
            }
        }
        return converted;
    }
}
